import './loaderRow.scss';

/**
 * Skeleton de una fila de la tabla de países durante la carga.
 */
const LoaderRow = () => {
  return (
    <tr className="countryTableRow countryTableRowSkeleton">
      <td className="countryFlagColumn">
        <div className="flagWrapper">
          <div className="flagBox fullSkeleton" />
        </div>
      </td>

      <td className="countryCurrencyColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="exchangeRateColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="taxesColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="phoneCodeColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="documentColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="providerColumn">
        <div className="labelCountryInput fullSkeleton skeletonLabel" />
        <div className="fullSkeleton skeletonInput" />
      </td>

      <td className="registryColumn">
        <div className="genericCheck fullSkeleton" />
      </td>

      <td className="buyColumn">
        <div className="genericCheck fullSkeleton" />
      </td>

      <td className="servicesColumn">
        <div className="genericCheck fullSkeleton" />
      </td>

      <td className="storageColumn">
        <div className="genericCheck fullSkeleton" />
      </td>

      <td className="costsCurrencyColumn">
        <div className="fullSkeleton skeletonSwitch" />
      </td>

      <td className="actionsColumn">
        <div className="saveButton fullSkeleton skeletonSaveButton" />
      </td>
    </tr>
  );
};

export default LoaderRow;
